import { Action, State } from './types'

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'selectedRows': {
      return {
        ...state,
        selectedRows: action.payload.data,
      }
    }
    case 'editMode': {
      return {
        ...state,
        selectiveEditModeEnabled: action.payload.isEnabled,
        selectedRows: {},
      }
    }
    case 'datasetTemplateId': {
      return {
        ...state,
        datasetTemplateId: action.payload.id,
      }
    }
    case 'setDatasetDataId': {
      return {
        ...state,
        datasetDataId: action.payload,
      }
    }
    case 'setModal': {
      const { bulkUploadOpen, resubmitOpen } = action.payload
      const { bulkUploadModalIsOpen, bulkResubmitModalIsOpen } = state

      return {
        ...state,
        bulkUploadModalIsOpen: bulkUploadOpen ?? bulkUploadModalIsOpen,
        bulkResubmitModalIsOpen: resubmitOpen ?? bulkResubmitModalIsOpen,
      }
    }
    case 'setManualEditLoading': {
      const { loading } = action.payload
      return {
        ...state,
        manualEditLoading: loading,
      }
    }
    case 'setSelectedCell': {
      return {
        ...state,
        selectedCell: action.payload,
      }
    }
    case 'setSelectedCells': {
      return {
        ...state,
        selectedCells: action.payload,
      }
    }
    case 'setSelectedRows': {
      return {
        ...state,
        selectedRows: action.payload,
      }
    }
    case 'setRowMode': {
      return {
        ...state,
        rowMode: action.payload,
      }
    }
    case 'manualEditRows': {
      const { datasetStructuresByDatasetId, canSubmitAll } = action.payload

      return {
        ...state,
        manualEdit: true,
        selectiveEditDatasetsById: datasetStructuresByDatasetId,
        manualEditCanSubmitAll: canSubmitAll,
        manualEditLoading: false,
      }
    }
    case 'closeManualEdit': {
      return {
        ...state,
        manualEdit: false,
      }
    }
    case 'closeSelectiveDataset': {
      return {
        ...state,
        manualEdit: false,
        manualEditCanSubmitAll: true,
      }
    }
    case 'removeRows': {
      const { removingRows } = action.payload
      return {
        ...state,
        removingRows,
      }
    }
    default:
      throw Error(`The action.type does not exist in the reducer.`, { cause: action })
  }
}
